import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import useUser from '../../hooks/useUser';
import Ventas from '../../components/Dashboard/Ventas';
import VentasEspecializados from '../../components/Dashboard/VentasEspecializados';
import Vendedor from '../../components/Dashboard/Vendedor';
import VendedorEspecializado from '../../components/Dashboard/VendedorEspecializado';
import Modelo from '../../components/Dashboard/Modelo';
import ModeloEspecializados from '../../components/Dashboard/ModeloEspecializados';
import Distribuidor from '../../components/Dashboard/Distribuidor';
import DistribuidorEspecializados from '../../components/Dashboard/DistribuidorEspecializados';
import Ranking from '../../components/Dashboard/Ranking';
import RankingVendedor from '../../components/Dashboard/RankingVendedor';
import RankingEspecializado from '../../components/Dashboard/RankingEspecializado';
import RankingActual from '../../components/Dashboard/RankingActual';
import RankingActualVendedor from '../../components/Dashboard/RankingActualVendedor';
import RankingActualEspecializado from '../../components/Dashboard/RankingActualEspecializado';
import RankingCampanaMes from '../../components/Dashboard/RankingCampanaMes';
import RankingSeccionesMes from '../../components/Dashboard/RankingSeccionesMes';
import RankingSeccionNorte from '../../components/Dashboard/RankingSeccionNorte';
import RankingSeccionCentro from '../../components/Dashboard/RankingSeccionCentro';
import RankingSeccionSur from '../../components/Dashboard/RankingSeccionSur'
import GanadoresSeccionNorte from '../../components/Dashboard/GanadoresSeccionNorte';
import GanadoresSeccionCentro from '../../components/Dashboard/GanadoresSeccionCentro';
import GanadoresSeccionSur from '../../components/Dashboard/GanadoresSeccionSur';
import GanadoresRegion from '../../components/Dashboard/GanadoresRegion';
import RankingFutbolero1 from '../../components/Dashboard/RankingFutbolero1';
import RankingFutbolero2 from '../../components/Dashboard/RankingFutbolero2';
import "./dashboard.css";

const VISTAS = {
  0: Ventas,
  1: Modelo,
  2: Vendedor,
  3: Distribuidor,
  4: Ranking,
  5: RankingActual,
  6: VentasEspecializados,
  7: ModeloEspecializados,
  8: VendedorEspecializado,
  9: DistribuidorEspecializados,
  10: RankingEspecializado,
  11: RankingActualEspecializado,
  12: RankingVendedor,
  13: RankingActualVendedor,
  15: RankingCampanaMes,
  16: RankingSeccionesMes,
  17: RankingSeccionNorte,
  18: RankingSeccionCentro,
  19: RankingSeccionSur,
  20: GanadoresSeccionNorte,
  21: GanadoresSeccionCentro,
  22: GanadoresSeccionSur,
  23: GanadoresRegion,
  24: RankingFutbolero1,
  25: RankingFutbolero2,
};

// Lista blanca de vistas a las que se puede enlazar por URL (?vista=clave).
// Solo se exponen aquí las vistas pensadas para compartirse como link directo;
// el resto de VISTAS sigue accesible únicamente desde el menú lateral.
const DEEP_LINK_VISTAS = Object.freeze({
  futbolero2: 25,
});

const mesActualLabel = () => {
  const mes = new Date().toLocaleString("es-ES", { month: "long" });
  return mes.charAt(0).toUpperCase() + mes.slice(1);
};

export default function Item() {
  const { tokenFull, IdUser, Puntos, Roles } = useUser();
  const [searchParams] = useSearchParams();
  const vistaKey = searchParams.get("vista");
  const vistaInicial = Object.prototype.hasOwnProperty.call(DEEP_LINK_VISTAS, vistaKey)
    ? DEEP_LINK_VISTAS[vistaKey]
    : 0;
  const [Vista, setVista] = useState(vistaInicial);

  const VistaActual = VISTAS[Vista];

  return <>
    <section className="fondo">
      <div className="container" style={{background: '#fff', paddingTop: 15, paddingBottom: 15}}>
        <div className="row">
          <div className="col-lg-2 col-md-3 borde">
            {
              (Roles === 'Admin' || Roles ==="Analista") &&
              <ul className="list-group margen">
                <li className={Vista == 0 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(0))}>Ventas</li>
                <li className={Vista == 1 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(1))}>Modelo</li>
                <li className={Vista == 2 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(2))}>Vendedor</li>
                <li className={Vista == 3 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(3))}>Distribuidor</li>
                <li className={Vista == 4 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(4))}>Lista de ganadores por mes</li>
                <li className={Vista == 13 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(13))}>Ranking del mes actual ({mesActualLabel()})</li>
                <li className={Vista == 24 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(24))}>Rank futbolero dinámica 1</li>
                <li className={Vista == 25 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(25))}>Rank futbolero dinámica 2</li>

{/*                 <li className={Vista == 17 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(17))}>Ranking Región Norte</li>
                <li className={Vista == 20 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(20))}>Lista de ganadores Región Norte</li>
                <li className={Vista == 18 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(18))}>Ranking Región Centro</li>
                <li className={Vista == 21 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(21))}>Lista de ganadores Región Centro</li>
                <li className={Vista == 19 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(19))}>Ranking Región Sur</li>
                <li className={Vista == 22 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(22))}>Lista de ganadores Región Sur</li>

                <li className={Vista == 15 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(15))}>Lista de ganadores de campaña Vivan los descuentos</li> */}

              </ul>
              || Roles === 'Vendedor' &&
              <ul className="list-group margen">
                <li className={Vista == 0 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(0))}>Ventas</li>
                <li className={Vista == 4 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(4))}>Lista de ganadores por mes</li>
                <li className={Vista == 5 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(5))}>Ranking del mes actual ({mesActualLabel()})</li>
                <li className={Vista == 24 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(24))}>Rank futbolero dinámica 1</li>
                <li className={Vista == 25 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(25))}>Rank futbolero dinámica 2</li>
{/*                 <li className={Vista == 15 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(15))}>Lista de ganadores de campaña Vivan los descuentos</li>
                <li className={Vista == 16 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(16))}>Ranking Regiones</li>
                <li className={Vista == 23 ? "list-group-item menu_dash_activo" : "list-group-item menu_dash"} onClick={(() => setVista(23))}>Lista de ganadores por Regiones</li> */}
              </ul>
              
            }
          </div>
          <div className="col-lg-10 col-md-9">
            {VistaActual && <VistaActual />}
          </div>
        </div>
      </div>
    </section>
  </>
}